var parent = require('../../stable/object/set-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/set-prototype-of.js
// module id = 483
// module chunks = 0 1